import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setHeaderColor, setHeaderTextColor, setloading } from '../../Redux/ActionCreater';
import axios from 'axios';
import PackageCards from '../Package/PackageCards';
import CommonBanner from '../Common/CommonBanner';
import { BASE_IMAGE_URL, BASE_URL } from '../../config';
import TrainerBanner from '../../Assets/images/chrismas-banner.webp';
import TrainerImg1 from '../../Assets/images/chrimas-img.webp';
import ChrismasVideoImg from '../../Assets/images/chrismas-video-img.webp';
import icon1 from "../../Assets/images/chrismas-icon-1.png";
import icon2 from "../../Assets/images/chrismas-icon-2.png";
import icon3 from "../../Assets/images/chrismas-icon-3.png";
import icon4 from "../../Assets/images/chrismas-icon-4.png";
import VideoModal from '../../Partial/VideoModal';
import PackageSection from './PackageSection';

const Adventskalender = () => {
  let dispatch = useDispatch();
  let [data, setData] = useState([]);
    const [isPopupVisible, setPopupVisible] = useState(false);
  let fetchData = async () => {
    try {
      dispatch(setloading(true));
      await axios.post(`${BASE_URL}/packages`)
        .then(res => {
          dispatch(setloading(false));
          if (res.data.responseCode === 1) {
            setData([...res.data.responseData.packages]);
          }
        })
    } catch (error) {
      console.log(error);
      dispatch(setloading(false));
    }
  }
    const handleImageClick = (e) => {
      e.preventDefault();
      setPopupVisible(true);
      clickPlayBtn();
    };
     const handleClosePopup = () => {
    setPopupVisible(false);
  };

  let clickPlayBtn = async () => {
    try {
      await axios
        .post(`${BASE_URL}/calender-video-count-update`, {

        })
        .then((res) => {
         
          if (res.data.responseCode === 1) {
            
          }
        });
    } catch (error) {
      console.log(error);
      dispatch(setloading(false));
    }
  };
  useEffect(() => {
    fetchData()
    dispatch(setHeaderColor('#dd0023'));
    dispatch(setHeaderTextColor('#fff'));
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <CommonBanner bannerImage={TrainerBanner} />
      <section className="chrismascontainer toppara trainertpdetails">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              {/* <h2>Mit Sicherheit durch deine Schwangerschaft –</h2> */}
              <div className="faq-des">
                <h3><strong>Weihnachtsworkout mit Sarah</strong></h3>
                <p>Zwischen Geschenkpapier, Plätzchenduft und Feiertagstrubel darfst du eines nicht vergessen: DICH</p>
                <p>Dieses Weihnachtsworkout ist dein kleiner Power-Moment inmitten der festlichen Zeit – für mehr Leichtigkeit, neue Energie und ein gutes Gefühl.</p>
                <p>Sarah begleitet dich durch eine stimmungsvolle Trainingseinheit, die dir körperlich und mental gut tut. Schnapp dir jetzt deine zwei neuen SHAPE Fitnessbänder in unserer limitierten Weihnachtsedition und leg direkt los – dein perfekter Begleiter für das Training mit Sarah!</p>
              </div>
              <div className="hexagoncontainer">
                <div className="row justify-content-center">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="hexarow">
                      {/* Item 1 */}
                      <div
                        className="hexacolumn hexa-1"
                        data-aos="fade-down"
                        data-aos-duration={1000}
                        data-aos-delay={100}
                      >
                        <div className="hexabx">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 292 338"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M291.5 85.9999L146.5 1L2 87.0001L1 252.5L145.5 337L291.5 252V85.9999Z"
                              fill="#F6F6F6"
                              stroke="#D3D3D3"
                            />
                          </svg>
                          <div className="hexainner">
                            <div className="hexatext">
                              <div className="hexatextimg">
                                <img src={icon1} alt="Sample 1" />
                              </div>
                              <p>Ein liebevoll gestaltetes Workout mit Weihnachtsfeeling</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Item 2 */}
                      <div
                        className="hexacolumn hexa-2"
                        data-aos="fade-down"
                        data-aos-duration={1000}
                        data-aos-delay={100}
                      >
                        <div className="hexabx">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 292 338"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M291.5 85.9999L146.5 1L2 87.0001L1 252.5L145.5 337L291.5 252V85.9999Z"
                              fill="#F6F6F6"
                              stroke="#D3D3D3"
                            />
                          </svg>
                          <div className="hexainner">
                            <div className="hexatext">
                              <div className="hexatextimg">
                                <img src={icon2} alt="Sample 2" />
                              </div>
                              <p> Für jedes<br></br>Fitnesslevel geeignet</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Item 3 */}
                      <div
                        className="hexacolumn hexa-3"
                        data-aos="fade-down"
                        data-aos-duration={1000}
                        data-aos-delay={100}
                      >
                        <div className="hexabx">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 292 338"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M291.5 85.9999L146.5 1L2 87.0001L1 252.5L145.5 337L291.5 252V85.9999Z"
                              fill="#F6F6F6"
                              stroke="#D3D3D3"
                            />
                          </svg>
                          <div className="hexainner">
                            <div className="hexatext">
                              <div className="hexatextimg">
                                <img src={icon3} alt="Sample 3" />
                              </div>
                              <p>Kurz, effektiv<br></br>& voller Motivation</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Item 4 */}
                      <div
                        className="hexacolumn hexa-4"
                        data-aos="fade-down"
                        data-aos-duration={1000}
                        data-aos-delay={100}
                      >
                        <div className="hexabx">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 292 338"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M291.5 85.9999L146.5 1L2 87.0001L1 252.5L145.5 337L291.5 252V85.9999Z"
                              fill="#F6F6F6"
                              stroke="#D3D3D3"
                            />
                          </svg>
                          <div className="hexainner">
                            <div className="hexatext">
                              <div className="hexatextimg">
                                <img src={icon4} alt="Sample 4" />
                              </div>
                              <p>Ein kleiner Vorgeschmack auf das, was dich bei SHAPE by Sarah Harrison erwartet</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="trainervideocontainer">
                <div className="row">
                  <div className="col-12">
                    <div className="trainervideoimg">
                      <a
                        href="javascript:void(0);"
                        onClick={(e) => handleImageClick(e)}
                        className="playbtn"
                      >
                        <i className="fa-solid fa-play"></i>
                      </a>
                      <img src={ChrismasVideoImg} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="trainercontent trainercontentlight trainercontentbg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" data-aos="fade-down" data-aos-duration={1000} data-aos-delay={100}>
              <div className="trainerrtimg">
                <img src={TrainerImg1} alt="" />
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 order-md-1" data-aos="fade-down" data-aos-duration={1000} data-aos-delay={100}>
              <div className="trainerltcontent">
                <h2>Lust auf mehr?</h2>
                <h3>Dann darfst du dich jetzt auf ein besonderes Christmas Special freuen: Nur für kurze Zeit sparst du -15% auf die erste Laufzeit deiner Mitgliedschaft mit dem Code CHRISTMAS15</h3>
                <p>Teste SHAPE by Sarah Harrison 7 Tage lang kostenlos! Dein Start in ein neues Körpergefühl, mehr Energie und echte Motivation.</p>
                <p>Ob du dich mit einem schnellen Power-Workout vom Alltagsstress befreien möchtest, beim Yoga zur Ruhe kommst oder dich im Zirkeltraining so richtig auspowerst - bei SHAPE findest du genau das, was dir guttut. Unten bei den Paketen siehst du bereits die reduzierten Preise.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="packageouter chrismaspackage" id="package">
        {/* <PackageCards data={data} /> */}
        <PackageSection/>
      </div>

      <div className="packagebtmtext">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12" data-aos="fade-down" data-aos-duration={1000} data-aos-delay={100}>
              <div className="packagetextinner">
                <p>Voller Vielfalt echter Motivation und dem Gefühl: ich mache das für mich.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
       <VideoModal
        show={isPopupVisible}
        videoSrc={`${BASE_IMAGE_URL}frontend/workout-adventskalender-1.mp4`}
        onClose={handleClosePopup}
        // title={videoTitle}
        // flag={showButton}
        // pdf={downloadPDF}
      />
    </>
  )
}

export default Adventskalender